import { API_PATHS } from '@/components/fakeDoor/constants';
import { isClient } from '@/utils/common';

// const LOCAL_BASE_URL = process.env.NEXT_LOCAL_BASE_URL;
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
const BASE_URL_MOTOR_ORCHESTRATOR =
    process.env.NEXT_INTERNAL_MOTOR_ORCHESTRATOR_BASE_URL;
const BASE_URL_ENTITY_SERVICE =
    process.env.NEXT_INTERNAL_ENTITY_SERVICE_BASE_URL;
const BASE_URL_ASSEST_MANAGEMENT =
    process.env.NEXT_INTERNAL_ASSEST_MANAGEMENT_BASE_URL;
const BASE_URL_VEHICLE_DETAILS =
    process.env.NEXT_PUBLIC_ACKODRIVE_WORKSPACE_BASE_URL_INTERNAL;

let NEXTJS_API_BASE_URL = '';

if (isClient()) {
    NEXTJS_API_BASE_URL =
        window.location.origin + process.env.NEXT_PUBLIC_ENV_PREFIX + '/api';
}

//Internal BE endpoints
export const API_ROUTES = {
    GARAGE_TIMELINE: `${BASE_URL}/v1/garage/timeline`,
    APPROVE_ESTIMATE: `${BASE_URL}/v1/assessment/proxy/line-items/approve`,
    SAVE_ESTIMATE: `${BASE_URL}/v1/assessment/proxy/line-items/status`,
    MOVE_TIMELINE: `${BASE_URL}/v1/garage/timeline/`,
    FETCH_ORDERID: `${BASE_URL}/v1/garage/users/timeline/`,
    USER_TIMELINE_V2: `${BASE_URL}/v1/garage/users/timeline-v2`,
    GET_USER_DETAILS: (ekey: any) =>
        `${BASE_URL_ENTITY_SERVICE}/api/user/get/?ekey=${ekey}`,
    // Welcome screen view status change
    HOME_PAGE_STATUS: (orderId: any) =>
        `${BASE_URL}/v1/garage/timeline/${orderId}`,
    FETCH_QC_UPDATES: (workOrderId: any) =>
        `${BASE_URL}/v1/assessment/proxy/qc-updates/${workOrderId}`,
    FETCH_HB_UPDATES: (workOrderId: any) =>
        `${BASE_URL}/v1/assessment/proxy/hb-updates/${workOrderId}`,
    GET_CITY_FROM_IP: (ip: string) =>
        `${process.env.NEXT_PUBLIC_ENV_BASE_IP_URL}/${ip}?key=${process.env.NEXT_PUBLIC_ENV_IP_API_KEY}`,
    FETCH_NEARBY_SERVICE_CENTRES: `${BASE_URL}/v1/garage/nearby-garages`,
    GET_SLOTS: (slot_type: any, pincode: any) =>
        `${BASE_URL}${API_PATHS.GET_SLOTS}?slot_type=${slot_type}&pincode=${pincode}`,
    SLOTS_AVAILABILITY: `${BASE_URL}${API_PATHS.GET_SLOTS_AVAILABILITY}`,
    GET_BOOKING_AMOUNT: (couponCode: any, garageId: any, serviceType: any) =>
        `${BASE_URL}/v1/appointment/booking-amount?code=${couponCode}&garage_id=${garageId}&service_type=${serviceType}`,
    BOOKING: `${BASE_URL}${API_PATHS.CREATE_BOOKING}`,
    APPOINTMENT: `${BASE_URL}${API_PATHS.CANCEL_APPOINTMENT}`,
    PACKAGE_PRICING: (garageId: any, modelId: any, fuelType: any) =>
        `${BASE_URL}${API_PATHS.GET_PACKAGE_PRICING}?garage=${garageId}&model_id=${modelId}&fuel_type=${fuelType}`,
    SERVICE_PRICING: (garageId: any, modelId: any, fuelType: any) =>
        `${BASE_URL}${API_PATHS.GET_SERVICE_PRICING}?garage=${garageId}&model_id=${modelId}&fuel_type=${fuelType}`,
    GET_CAR_SERVICEABLE: (garageId: any, make: any) =>
        `${BASE_URL}${API_PATHS.GET_CAR_SERVICEABLE}?garage_id=${garageId}&make=${make}`,
    PINCODE_MAPPING: `${BASE_URL}${API_PATHS.GET_PINCODE_MAPPING}`,
    GET_GARAGE_DETAILS_FROM_CITY: `${BASE_URL}${API_PATHS.GET_GARAGE_DETAILS_FROM_CITY}`,
    GET_GARAGE_DETAILS: `${BASE_URL}${API_PATHS.GET_GARAGE_DETAILS}`,
    GET_PINCODE_FROM_USERID: `${BASE_URL}${API_PATHS.GET_PINCODE_FROM_USERID}`,
    QR_CAMPAIGN_OFFER_VALIDATION: (carNumber: any, garageId: any) =>
        `${BASE_URL}/v1/campaign/qr/offer_validation?car_registration_number=${carNumber}&utm_medium=qr_online_campaign&garage_id=${garageId}`,
    QR_CAMPAIGN_DETAILS: (utm_medium: any) =>
        `${BASE_URL}/v1/campaign/qr/?utm_medium=${utm_medium}`,
    QR_CAMPAIGN_COLORS: (utm_medium: any) =>
        `${BASE_URL}/v1/campaign/qr/colors?utm_medium=${utm_medium}`,
    POLICY_DETAILS: `${BASE_URL_MOTOR_ORCHESTRATOR}${API_PATHS.GET_POLICY_DETAILS}`,
    GET_SAVED_ASSETS: `${BASE_URL_ASSEST_MANAGEMENT}${API_PATHS.GET_SAVED_ASSETS}`,
    CREATE_VEHICLE: `${BASE_URL_ASSEST_MANAGEMENT}${API_PATHS.CREATE_ASSET}`,
    GET_VEHICLE_INFO: (id: any) =>
        `${BASE_URL}/v1/garage/vis/vehicle-image?model_id=${id}`,
    CREATE_TYPEFORM_LINK: `${BASE_URL}${API_PATHS.CREATE_TYPEFORM_LINK}`,
    USERS_ADDRESS: `${BASE_URL}/v1/garage/users/address`,
    REPEAT_APPOINTMENT: `${BASE_URL}/v1/appointment/repeat`,
    SERVICE_REMINDERS: `${BASE_URL}/v1/garage/service-reminders`,
    FETCH_REWARD_DETAILS: `${BASE_URL}/v1/garage/rewards/fetch`,
    EXTRACT_REWARD_DETAILS: `${BASE_URL}/v1/garage/rewards/extract`,
    GET_REWARD_DETAILS_FROM_ID: `${BASE_URL}/v1/garage/rewards/details`,
    GET_VEHICLE_DETAILS: (regNo: string, source: string) =>
        `${BASE_URL_VEHICLE_DETAILS}${API_PATHS.GET_VEHICLE_DETAILS}?registration_number=${regNo}&source=${source}`,
    USER_POLICY_PROFILE: `${BASE_URL}/v1/garage/users/policy-holder`,
    MAPS_AUTOCOMPLETE: `${BASE_URL_VEHICLE_DETAILS}/service/autocomplete`,
    MAPS_GEOCODE: `${BASE_URL_VEHICLE_DETAILS}/service/place-details`,
    GET_PINCODE_FROM_IP: (ip: string) =>
        `${process.env.NEXT_PUBLIC_ENV_BASE_IP_URL}/${ip}?key=${process.env.NEXT_PUBLIC_ENV_IP_API_KEY}`,
    GET_CDP_DATA: `${BASE_URL}/v1/garage/users/cdp/pincode`,
    GET_PINCODE_FROM_LATITUDE_LONGITUDE: (
        latitude: number,
        longitude: number
    ) =>
        `${BASE_URL}/v1/garage/users/google-maps/pincode?latitude=${latitude}&longitude=${longitude}`,
    GET_PINCODE_BY_GARAGE_ID: `${BASE_URL}/v1/garage/default-garage-pincode`,
    PUD_TRACKER: `${BASE_URL}/v1/pud/data`,
};

export const NEXTJS_API_ROUTES = {
    FETCH_NEARBY_SERVICE_CENTRES: `${NEXTJS_API_BASE_URL}/get-nearby-garages`,
    GET_SLOTS: (slot_type: any, pincode: any) =>
        `${NEXTJS_API_BASE_URL}/get-slots?slot_type=${slot_type}&pincode=${pincode}`,
    SLOTS_AVAILABILITY: (
        slot_type: string,
        pincode: string,
        latitude: any,
        longitude: any
    ) =>
        `${NEXTJS_API_BASE_URL}/slot-availability?slot_type=${slot_type}&pincode=${pincode}&latitude=${latitude}&longitude=${longitude}`,
    GET_BOOKING_AMOUNT: (
        couponCode: string,
        garageId: string,
        serviceType: string
    ) =>
        `${NEXTJS_API_BASE_URL}/get-booking-amount?coupon_code=${couponCode}&garage_id=${garageId}&service_type=${serviceType}`,
    BOOKING: `${NEXTJS_API_BASE_URL}/booking`,
    APPOINTMENT: `${NEXTJS_API_BASE_URL}/appointment`,
    PACKAGE_PRICING: (garageId: any, modelId: any, fuelType: any) =>
        `${NEXTJS_API_BASE_URL}/package-pricing?garage=${garageId}&model_id=${modelId}&fuel_type=${fuelType}`,
    SERVICE_PRICING: (garageId: any, modelId: any, fuelType: any) =>
        `${NEXTJS_API_BASE_URL}/service-pricing?garage=${garageId}&model_id=${modelId}&fuel_type=${fuelType}`,
    GET_CAR_SERVICEABLE: (garageId: any, make: any) =>
        `${NEXTJS_API_BASE_URL}/get-car-serviceable?garage_id=${garageId}&make=${make}`,
    PINCODE_MAPPING: `${NEXTJS_API_BASE_URL}/pincode-mapping`,
    GET_PINCODE_BY_GARAGE_ID: `${NEXTJS_API_BASE_URL}/get-pincode-by-garage-id`,
    GET_GARAGE_DETAILS_FROM_CITY: `${NEXTJS_API_BASE_URL}/garage-details-from-city`,
    GET_GARAGE_DETAILS_FROM_ID: `${NEXTJS_API_BASE_URL}/garage-details-from-id`,
    GET_PINCODE_FROM_USERID: `${NEXTJS_API_BASE_URL}/pincode-from-user-id`,
    GARAGE_TIMELINE: `${NEXTJS_API_BASE_URL}/garage-timeline`,
    QR_CAMPAIGN_OFFER_VALIDATION: (carNumber: any, garageId: any) =>
        `${NEXTJS_API_BASE_URL}/qr-campaign-offer-validation?car_registration_number=${carNumber}&utm_medium=qr_online_campaign&garage_id=${garageId}`,
    QR_CAMPAIGN_DETAILS: (utm_medium: any) =>
        `${NEXTJS_API_BASE_URL}/qr-campaign?utm_medium=${utm_medium}`,
    QR_CAMPAIGN_COLORS: (utm_medium: any) =>
        `${NEXTJS_API_BASE_URL}/qr-campaign-colors?utm_medium=${utm_medium}`,
    APPROVE_ESTIMATE: `${NEXTJS_API_BASE_URL}/line-item-approve`,
    SAVE_ESTIMATE: `${NEXTJS_API_BASE_URL}/line-item-status`,
    FETCH_HB_UPDATES: (workOrderId: any) =>
        `${NEXTJS_API_BASE_URL}/repair-update?tags=HEARTBEAT&work_order_id=${workOrderId}`,
    GET_SAVED_ASSETS: `${NEXTJS_API_BASE_URL}/get-saved-assets`,
    CREATE_VEHICLE: `${NEXTJS_API_BASE_URL}/create-vehicle`,
    GET_VEHICLE_INFO: (id: any) =>
        `${NEXTJS_API_BASE_URL}/get-vehicle-info?id=${id}`,
    CREATE_TYPEFORM_LINK: `${NEXTJS_API_BASE_URL}/create-typeform-link`,
    USERS_ADDRESS: `${NEXTJS_API_BASE_URL}/users-address`,
    SERVICE_REMINDERS: `${NEXTJS_API_BASE_URL}/service-reminders`,
    FETCH_REWARD_DETAILS: `${NEXTJS_API_BASE_URL}/fetch-reward-details`,
    EXTRACT_REWARD_DETAILS: `${NEXTJS_API_BASE_URL}/extract-reward-details`,
    GET_REWARD_DETAILS_FROM_ID: `${NEXTJS_API_BASE_URL}/get-reward-details-from-id`,
    GET_VEHICLE_DETAILS: (regNo: string) =>
        `${NEXTJS_API_BASE_URL}/get-vehicle-details?registration_number=${regNo}`,
    MAPS_AUTOCOMPLETE: `${NEXTJS_API_BASE_URL}/maps/autocomplete`,
    MAPS_GEOCODE: `${NEXTJS_API_BASE_URL}/maps/geocode`,
    GET_PINCODE_FROM_LATITUDE_LONGITUDE: `${NEXTJS_API_BASE_URL}/get-pincode-from-latitude-longitude`,
};
